define('models/ConfigurationCollection',['underscore','ObjectCollection','LocalStorage','models/ConfigurationModel'],function (_,ObjectCollection,LocalStorage,ConfigurationModel) {
    //
    // Collection Configuration
    //
    var ConfigurationCollectionPrototype = {
        
        name:'ConfigurationCollection',
        route:'apiConfigurationCollection',
        model:ConfigurationModel,
        initialize:function(){
            // ObjectCollection constructor heritage
            var model = this;
            ObjectCollection.prototype.initialize.apply(model,arguments);
            //
            model.on('sync',model.onSync,model);
            //
        },
        getValue:function(key,defaultValue){
            var find = this.findWhere({name:key});
            if(_.isUndefined(find)){
                if(_.isUndefined(defaultValue)){
                    return key;
                }
                return defaultValue;
            }else{
                return find.get('value')
            }
        }
    };

    var ConfigurationCollection = ObjectCollection.extend(LocalStorage).extend(ConfigurationCollectionPrototype);

    return ConfigurationCollection;
});
